import { WiredTemperatureSensor } from 'z3k-config';
import { getOwaMultiplier, getOwaUnitCode, isMicrolineAdapter } from 'utils';
export function pressureScaleForMLAdapter(sensor) {
    switch (WiredTemperatureSensor.getPressureType(sensor)) {
        case WiredTemperatureSensor.PressureType.BAR5:
            return 1 / 16;
        case WiredTemperatureSensor.PressureType.BAR8:
            return 1 / 10;
        case WiredTemperatureSensor.PressureType.BAR12:
            return 3 / 20;
        default:
            return 1;
    }
}
export function z3kOwaMultiplier(sensor) {
    if (isMicrolineAdapter(sensor.serial)) {
        return pressureScaleForMLAdapter(sensor);
    }
    const unit_code = getOwaUnitCode(sensor.serial);
    if (unit_code == null) {
        return 1;
    }
    return getOwaMultiplier(unit_code);
}
